module.exports = __webpack_public_path__ + "img/智能实训-图片1.063ae8c8.png";